import { MyCampApp } from './enumerations';

export class ApiEndpointInfo
{
    environment: MyCampApp.Environment;
    baseUrl: string;

    constructor(environment: MyCampApp.Environment, baseUrl: string)
    {
        this.environment = environment;
        this.baseUrl = baseUrl;
    }
}
